import React from 'react';
import CustomDropdown from '../../base/custom-dropdown';
import { IGetBeneficiary } from '../../../models/beneficiary.model';
import PaymentBadge from '../../base/payment-badge';
import { getBeneficiaryProperty } from '../../../utils/beneficiary.util';
import { useBeneficiaryStore } from '../../../store';
import usePayoutStore from '../../../store/payout';

interface ExistingBeneficiaryProps {
  beneficiaries: IGetBeneficiary[] | undefined;
  showAddBeneficiaryForm: () => void;
}

const ExistingBeneficiary: React.FC<ExistingBeneficiaryProps> = ({
  beneficiaries,
  showAddBeneficiaryForm,
}: ExistingBeneficiaryProps) => {
  const { beneficiaryPayload, setBeneficiaryPayload } = useBeneficiaryStore();
  const { payoutPayload, setPayoutPayload } = usePayoutStore();

  const handleBeneficiarySelect = (value: any) => {
    setBeneficiaryPayload({
      ...value,
      beneficiaryAddress: {
        ...value.beneficiaryAddress,
        fullAddress: `${value.beneficiaryAddress.streetLine1}, ${value.beneficiaryAddress.city}, ${value.beneficiaryAddress.state}, ${value.beneficiaryAddress.countryCode}, ${value.beneficiaryAddress.postalCode}`,
      },
    });
    setPayoutPayload({ ...payoutPayload, beneficiaryId: value.id });
    showAddBeneficiaryForm();
  };

  return (
    <div>
      <CustomDropdown
        label="Select Beneficiary"
        options={
          beneficiaries?.map((beneficiary) => ({
            value: beneficiary.accountHolderName,
            label: beneficiary.accountHolderName,
            name: beneficiary.accountHolderName,
            accountNumber: getBeneficiaryProperty(beneficiary),
            ...beneficiary,
          })) || []
        }
        emitObject
        renderItem={(option) => (
          <div className="flex items-center justify-between">
            <div>
              <p>{option.name}</p>
              <p>
                <span className="text-gray-text">{option.bankName}</span> /{' '}
                <span>{option.accountNumber}</span>
              </p>
            </div>
            <div>
              <PaymentBadge paymentType={option.paymentType} />
            </div>
          </div>
        )}
        selectedValue={beneficiaryPayload.accountHolderName || ''}
        onSelectChange={handleBeneficiarySelect}
      />
    </div>
  );
};

export default ExistingBeneficiary;
